import { Component } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  QPointDateTimePickerComponent,
} from '../../../../../projects/qpoint-forms/src/lib/datetime-picker/datetime-picker.component';


@Component({
    selector: 'qpoint-datetime-picker-demo',
    templateUrl: './datetime-picker-demo.component.html',
    styleUrls: ['./datetime-picker-demo.component.scss'],
    imports: [FormsModule, QPointDateTimePickerComponent, ReactiveFormsModule]
})
export class DateTimePickerDemoComponent {
  public readonly = false;
  public dateReadonly = false;
  public disabled = false;
  public clearable = true;

  public fc = new FormControl(null);

  constructor() {}
}
